(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2711);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ HomePage; },
  "dynamic": function() { return /* binding */ pages_dynamic; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./services/api.js + 41 modules
var api = __webpack_require__(8382);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/home/call-to-action.js


function HomeCallToAction() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "ds-call-to-action ptb-120 position-relative overflow-hidden z-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "gradient-overlay position-absolute start-0 top-0 w-100 h-100 z-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/img/dealers/purplecar.jpg",
                    alt: "not found",
                    fill: true,
                    style: {
                        objectFit: "cover",
                        objectPosition: "right center",
                        zIndex: -1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xl-7 col-lg-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "section-content text-center position-relative z-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "h1 text-white mb-3",
                                        children: "Fazemos Os Melhores Neg\xf3cios"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-5 text-white",
                                        children: "Buscamos sempre a excel\xeancia em nossas negocia\xe7\xf5es tanto na compra como na venda de ve\xedculos. A satisfa\xe7\xe3o do cliente \xe9 nosso maior objetivo."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "cta-btns-wrapper d-flex align-items-center justify-content-center flex-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/estoque",
                                                className: "btn header-white-btn",
                                                children: "Ver Estoque Completo"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/venda-seu-veiculo",
                                                className: "btn header-white-btn",
                                                children: "Venda Seu Ve\xedculo"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(2546);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(9901);
;// CONCATENATED MODULE: ./src/components/home/hero.js






function HomeHero(param) {
    let { banners  } = param;
    const router = (0,next_router.useRouter)();
    const { handleSubmit , register  } = (0,index_esm/* useForm */.cI)();
    const onSubmit = (data)=>{
        if (data.txtFilter) router.query.filter = data.txtFilter;
        router.push("/estoque?".concat(new URLSearchParams(router.query)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            banners.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "dealership-hero position-relative overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    autoplay: true,
                    loop: true,
                    speed: 1500,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        clickable: true
                    },
                    modules: [
                        swiper_esm/* Pagination */.tl,
                        swiper_esm/* EffectFade */.xW,
                        swiper_esm/* Autoplay */.pt
                    ],
                    children: banners.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dl-hero-single",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "at_hero_slider",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "at-hero-banner",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.banner.imageUrl,
                                            alt: "banner",
                                            width: 1440,
                                            height: 420,
                                            sizes: "100vw",
                                            priority: true,
                                            style: {
                                                width: "100%",
                                                height: "auto",
                                                objectFit: "cover"
                                            }
                                        })
                                    })
                                })
                            })
                        }, index))
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "at-search-box overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white rounded iv_sidebar_widget",
                                style: {
                                    padding: "16px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                    className: "ct-form-wrapper",
                                    onSubmit: handleSubmit(onSubmit),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row g-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-9",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "input-field",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: "Filtre por marca ou modelo",
                                                        ...register("txtFilter")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-3 submit-btn align-self-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    className: "btn btn-secondary btn-md",
                                                    type: "submit",
                                                    children: "Buscar Agora"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/home/last-offers.js
var last_offers = __webpack_require__(5587);
;// CONCATENATED MODULE: ./src/components/home/what-our-customer-says.js



const dynamic = "force-dynamic";
function HomeWhatOurCustomerSays() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "eq-feedback-section ptb-120",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row align-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xl-6 col-lg-9",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "section-title ps-sm-3 text-center text-lg-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "mb-2 text-eq-primary",
                                        children: "Excel\xeancia em Atendimento"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-3 fw-bold text-black",
                                        children: "O Que Nossos Clientes Dizem?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0",
                                        children: "Est\xe1 em nosso DNA dar o melhor atendimento aos nossos clientes, gerando a melhor experi\xeancia de compra de ve\xedculos do mercado."
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-5 px-sm-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                            speed: 3500,
                            slidesPerView: 3,
                            spaceBetween: 24,
                            autoplay: {
                                delay: 3500,
                                disableOnInteraction: false
                            },
                            loop: true,
                            pagination: {
                                el: ".eq-feedback-pagination",
                                type: "bullets",
                                clickable: true
                            },
                            breakpoints: {
                                [0]: {
                                    slidesPerView: 1
                                },
                                [768]: {
                                    slidesPerView: 2
                                },
                                [1200]: {
                                    slidesPerView: 3
                                }
                            },
                            modules: [
                                swiper_esm/* Pagination */.tl,
                                swiper_esm/* Autoplay */.pt
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide eq-feedback-single position-relative bg-white rounded overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "star-badge text-white position-absolute end-0 top-0 fs-sm fw-bold",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-solid fa-star"
                                                }),
                                                "5.0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "quote-icon d-inline-flex align-items-center justify-content-center rounded-circle position-relative",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "19",
                                                height: "17",
                                                viewBox: "0 0 19 17",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M6.57941 7.84822H4.02222C3.71778 7.84822 3.45896 7.7417 3.24584 7.52858C3.03284 7.31546 2.9262 7.05672 2.9262 6.7522V6.38706C2.9262 5.58028 3.21165 4.89158 3.78251 4.32072C4.35334 3.75006 5.04216 3.4646 5.84885 3.4646H6.57941C6.77726 3.4646 6.94843 3.39227 7.0931 3.24773C7.23768 3.1031 7.30998 2.93193 7.30998 2.73404V1.27268C7.30998 1.07483 7.23764 0.903495 7.0931 0.75887C6.94847 0.614445 6.7773 0.541992 6.57941 0.541992H5.84885C5.05727 0.541992 4.30208 0.696254 3.58279 1.00434C2.86358 1.31262 2.2415 1.72934 1.7163 2.25454C1.19114 2.7795 0.774534 3.40163 0.466291 4.12092C0.158048 4.84012 0.00390625 5.59552 0.00390625 6.38702V14.4236C0.00390625 15.0328 0.216906 15.55 0.643104 15.9764C1.06934 16.4025 1.58699 16.6155 2.1958 16.6155H6.57969C7.18846 16.6155 7.70595 16.4025 8.13223 15.9764C8.55834 15.55 8.77146 15.0328 8.77146 14.4236V10.0401C8.77146 9.43106 8.55834 8.91382 8.13195 8.48742C7.70587 8.06134 7.18818 7.84822 6.57941 7.84822Z",
                                                        fill: "#F6F6F6"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M18.3607 8.48742C17.9346 8.06134 17.4171 7.84822 16.8081 7.84822H14.251C13.9467 7.84822 13.6876 7.7417 13.4749 7.52858C13.2617 7.31546 13.1552 7.05672 13.1552 6.7522V6.38706C13.1552 5.58028 13.4407 4.89158 14.0113 4.32072C14.5819 3.75006 15.2707 3.4646 16.0778 3.4646H16.8082C17.0061 3.4646 17.1773 3.39227 17.3219 3.24773C17.4664 3.1031 17.5389 2.93193 17.5389 2.73404V1.27268C17.5389 1.07483 17.4664 0.903495 17.3219 0.75887C17.1774 0.614445 17.0061 0.541992 16.8082 0.541992H16.0778C15.2857 0.541992 14.5307 0.696254 13.8112 1.00434C13.0921 1.31262 12.4703 1.72934 11.9451 2.25454C11.4199 2.7795 11.003 3.40163 10.6949 4.12092C10.3868 4.84012 10.2324 5.59552 10.2324 6.38702V14.4236C10.2324 15.0328 10.4456 15.55 10.8717 15.9764C11.2978 16.4025 11.8153 16.6155 12.4242 16.6155H16.8079C17.4168 16.6155 17.9343 16.4025 18.3604 15.9764C18.7868 15.55 18.9995 15.0328 18.9995 14.4236V10.0401C18.9996 9.43102 18.7868 8.91382 18.3607 8.48742Z",
                                                        fill: "#F6F6F6"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 mb-3 fs-md",
                                            children: "Com certeza uma das melhores ag\xeancias de ve\xedculoas da regi\xe3o."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-5 clients_name position-relative fw-bold text-black",
                                            children: "Fillipe Marcus"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide eq-feedback-single position-relative bg-white rounded overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "star-badge text-white position-absolute end-0 top-0 fs-sm fw-bold",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-solid fa-star"
                                                }),
                                                "4.9"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "quote-icon d-inline-flex align-items-center justify-content-center rounded-circle position-relative",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "19",
                                                height: "17",
                                                viewBox: "0 0 19 17",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M6.57941 7.84822H4.02222C3.71778 7.84822 3.45896 7.7417 3.24584 7.52858C3.03284 7.31546 2.9262 7.05672 2.9262 6.7522V6.38706C2.9262 5.58028 3.21165 4.89158 3.78251 4.32072C4.35334 3.75006 5.04216 3.4646 5.84885 3.4646H6.57941C6.77726 3.4646 6.94843 3.39227 7.0931 3.24773C7.23768 3.1031 7.30998 2.93193 7.30998 2.73404V1.27268C7.30998 1.07483 7.23764 0.903495 7.0931 0.75887C6.94847 0.614445 6.7773 0.541992 6.57941 0.541992H5.84885C5.05727 0.541992 4.30208 0.696254 3.58279 1.00434C2.86358 1.31262 2.2415 1.72934 1.7163 2.25454C1.19114 2.7795 0.774534 3.40163 0.466291 4.12092C0.158048 4.84012 0.00390625 5.59552 0.00390625 6.38702V14.4236C0.00390625 15.0328 0.216906 15.55 0.643104 15.9764C1.06934 16.4025 1.58699 16.6155 2.1958 16.6155H6.57969C7.18846 16.6155 7.70595 16.4025 8.13223 15.9764C8.55834 15.55 8.77146 15.0328 8.77146 14.4236V10.0401C8.77146 9.43106 8.55834 8.91382 8.13195 8.48742C7.70587 8.06134 7.18818 7.84822 6.57941 7.84822Z",
                                                        fill: "#F6F6F6"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M18.3607 8.48742C17.9346 8.06134 17.4171 7.84822 16.8081 7.84822H14.251C13.9467 7.84822 13.6876 7.7417 13.4749 7.52858C13.2617 7.31546 13.1552 7.05672 13.1552 6.7522V6.38706C13.1552 5.58028 13.4407 4.89158 14.0113 4.32072C14.5819 3.75006 15.2707 3.4646 16.0778 3.4646H16.8082C17.0061 3.4646 17.1773 3.39227 17.3219 3.24773C17.4664 3.1031 17.5389 2.93193 17.5389 2.73404V1.27268C17.5389 1.07483 17.4664 0.903495 17.3219 0.75887C17.1774 0.614445 17.0061 0.541992 16.8082 0.541992H16.0778C15.2857 0.541992 14.5307 0.696254 13.8112 1.00434C13.0921 1.31262 12.4703 1.72934 11.9451 2.25454C11.4199 2.7795 11.003 3.40163 10.6949 4.12092C10.3868 4.84012 10.2324 5.59552 10.2324 6.38702V14.4236C10.2324 15.0328 10.4456 15.55 10.8717 15.9764C11.2978 16.4025 11.8153 16.6155 12.4242 16.6155H16.8079C17.4168 16.6155 17.9343 16.4025 18.3604 15.9764C18.7868 15.55 18.9995 15.0328 18.9995 14.4236V10.0401C18.9996 9.43102 18.7868 8.91382 18.3607 8.48742Z",
                                                        fill: "#F6F6F6"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 mb-3 fs-md",
                                            children: "O atendimento da BNDV Ve\xedculos foi muito bom, farei outros neg\xf3cios com certeza. Super recomendo!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-5 clients_name position-relative fw-bold text-black",
                                            children: "Jailson Almeida"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide eq-feedback-single position-relative bg-white rounded overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "star-badge text-white position-absolute end-0 top-0 fs-sm fw-bold",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-solid fa-star"
                                                }),
                                                "5.0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "quote-icon d-inline-flex align-items-center justify-content-center rounded-circle position-relative",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "19",
                                                height: "17",
                                                viewBox: "0 0 19 17",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M6.57941 7.84822H4.02222C3.71778 7.84822 3.45896 7.7417 3.24584 7.52858C3.03284 7.31546 2.9262 7.05672 2.9262 6.7522V6.38706C2.9262 5.58028 3.21165 4.89158 3.78251 4.32072C4.35334 3.75006 5.04216 3.4646 5.84885 3.4646H6.57941C6.77726 3.4646 6.94843 3.39227 7.0931 3.24773C7.23768 3.1031 7.30998 2.93193 7.30998 2.73404V1.27268C7.30998 1.07483 7.23764 0.903495 7.0931 0.75887C6.94847 0.614445 6.7773 0.541992 6.57941 0.541992H5.84885C5.05727 0.541992 4.30208 0.696254 3.58279 1.00434C2.86358 1.31262 2.2415 1.72934 1.7163 2.25454C1.19114 2.7795 0.774534 3.40163 0.466291 4.12092C0.158048 4.84012 0.00390625 5.59552 0.00390625 6.38702V14.4236C0.00390625 15.0328 0.216906 15.55 0.643104 15.9764C1.06934 16.4025 1.58699 16.6155 2.1958 16.6155H6.57969C7.18846 16.6155 7.70595 16.4025 8.13223 15.9764C8.55834 15.55 8.77146 15.0328 8.77146 14.4236V10.0401C8.77146 9.43106 8.55834 8.91382 8.13195 8.48742C7.70587 8.06134 7.18818 7.84822 6.57941 7.84822Z",
                                                        fill: "#F6F6F6"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M18.3607 8.48742C17.9346 8.06134 17.4171 7.84822 16.8081 7.84822H14.251C13.9467 7.84822 13.6876 7.7417 13.4749 7.52858C13.2617 7.31546 13.1552 7.05672 13.1552 6.7522V6.38706C13.1552 5.58028 13.4407 4.89158 14.0113 4.32072C14.5819 3.75006 15.2707 3.4646 16.0778 3.4646H16.8082C17.0061 3.4646 17.1773 3.39227 17.3219 3.24773C17.4664 3.1031 17.5389 2.93193 17.5389 2.73404V1.27268C17.5389 1.07483 17.4664 0.903495 17.3219 0.75887C17.1774 0.614445 17.0061 0.541992 16.8082 0.541992H16.0778C15.2857 0.541992 14.5307 0.696254 13.8112 1.00434C13.0921 1.31262 12.4703 1.72934 11.9451 2.25454C11.4199 2.7795 11.003 3.40163 10.6949 4.12092C10.3868 4.84012 10.2324 5.59552 10.2324 6.38702V14.4236C10.2324 15.0328 10.4456 15.55 10.8717 15.9764C11.2978 16.4025 11.8153 16.6155 12.4242 16.6155H16.8079C17.4168 16.6155 17.9343 16.4025 18.3604 15.9764C18.7868 15.55 18.9995 15.0328 18.9995 14.4236V10.0401C18.9996 9.43102 18.7868 8.91382 18.3607 8.48742Z",
                                                        fill: "#F6F6F6"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 mb-3 fs-md",
                                            children: "Sou cliente da BNDV Ve\xedculos e posso garantir que eles possuem um excelente atendimento."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-5 clients_name position-relative fw-bold text-black",
                                            children: "Anderson Mota Almeida"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/layout/footer.js
var footer = __webpack_require__(9432);
// EXTERNAL MODULE: ./src/components/layout/header.js
var header = __webpack_require__(392);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/pages/index.js










var __N_SSP = true;
const pages_dynamic = "force-dynamic";
function HomePage(param) {
    let { companyGeneralData , adsLastOffers , banners  } = param;
    companyGeneralData = JSON.parse(companyGeneralData);
    const [siteSettings, setSiteSettings] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,api/* fetchGetCompanySiteSettings */.XQ)().then((res)=>{
            res.facebookDomainVerificationCode ? setSiteSettings(res.facebookDomainVerificationCode) : null;
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "".concat(companyGeneralData.company.nickName.toUpperCase(), "Revenda de ve\xedculos multimarcas, novos e semi-novos em ").concat(companyGeneralData.company.city ? companyGeneralData.company.city : "", ". Ve\xedculos com proced\xeancia e garantia.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "https://bndv.com.br"
                    }),
                    siteSettings.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: siteSettings
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(companyGeneralData.company.nickName.toUpperCase(), " - ").concat(companyGeneralData.company.city ? companyGeneralData.company.city : "", " ")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "main-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        company: companyGeneralData.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeHero, {
                        banners: banners
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(last_offers/* default */.Z, {
                        ads: adsLastOffers
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCallToAction, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeWhatOurCustomerSays, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {
                        company: companyGeneralData.company
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [959,333,536,297,822,587,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);